import * as React from 'react';
import { useGetUserQuery } from "../../../apis/User.api";
import { PrimaryUser, User } from "../../../types/models/User";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: User;
};

export const UserNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.email }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const UserName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetUserQuery(PrimaryUser.fromId(id))
    return (<UserNameDisplay data={data}/>)
}

export default UserName;
